<script setup lang="ts">
import { computed } from 'vue';
import { SearchTab } from '@/core/sourcing/search/types/search-tab.enum';
import UserSearchSourcing from '@/assets/svg/sourcing/users-search-sourcing.svg';
import SkipForwardIcon from '@/assets/svg/sourcing/skip-forward.svg';

const props = defineProps<{
  activeTab: SearchTab;
}>();

const isMatchesTab = computed(() => props.activeTab === SearchTab.MATCHES);

const title = computed(() =>
  isMatchesTab.value ? 'No more matches on this page' : 'No skipped candidates',
);

const subtitle = computed(() =>
  isMatchesTab.value
    ? 'Candidates you skipped are in Skipped if you want to review or restore them.'
    : 'Candidates you skip will appear here. You can review or restore them anytime.',
);
</script>

<template>
  <section class="my-20 flex flex-col items-center text-sm text-shade-800">
    <div class="flex h-32 w-32 items-center justify-center rounded-full bg-tint-20">
      <img :src="UserSearchSourcing" v-if="isMatchesTab" class="big-icon" />
      <img :src="SkipForwardIcon" v-else class="big-icon" />
    </div>
    <div class="w-60 text-center">
      <p class="mt-4 font-bold">{{ title }}</p>
      <p class="mt-2">{{ subtitle }}</p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.big-icon {
  @apply h-14 w-14 opacity-50;
}
</style>
